<template lang="pug">
v-row
  v-col(cols="12" md="3")
    v-select(
      v-model="groupType" 
      :items="groupTypeOptions"
      label="組別"
      hide-details
    )
  v-col(cols="6" md="3")
    v-select(
      v-model="districtName" 
      :items="districtOptions"
      :disabled="groupType === ''"
      label="牧區"
      hide-details
    )
  v-col(cols="6" md="3")
    v-select(
      v-model="groupId" 
      :items="groupOptions"
      item-text="groupName"
      item-value="groupId"
      :disabled="districtName === ''"
      label="小組"
      hide-details
    )
</template>

<script>
export default {
  name: 'Group',
  props: ['searchGroupId'],
  data: () => ({
    groupType: '',
    districtName: '',
    groupId: ''
  }),
  watch: {
    groupType (val) {
      if (val)  {
        this.districtName = ''
        this.groupId = ''
      }
    },
    districtName (val) {
      if (val === '')  this.groupId = ''
    },
    searchGroupId (val) {
      if (val === null) {
        this.groupType = ''
        this.groupId = val
      }
    },
    groupId (val) {
      this.$emit('groupId', val)
    }
  },
  computed: {
    groupTypeOptions () {
      return this.$store.state.group.groupType
    },
    groups () {
      return this.$store.state.group.group
    },
    districtOptions () {
      const groupMap = this.groups
        .filter(group => group.groupTypeName === this.groupType)
        .reduce((acc, g) => {
          acc[g.districtName] = true
          return acc
        }, {})
      return Object.keys(groupMap).map(g => {return g})
    },
    groupOptions () {
      return this.groups
        .filter(g => g.districtName === this.districtName)
        .map(g => ({ groupName: g.groupName, groupId: g.groupId }))
    },
  },
}
</script>
